<template>
  <Panel lineColor="var(--primary-color)" class="panel">
    <div class="container-panel">
      <h4 class="text-start">Integração facebook catálogos</h4>
      <LineDivider />

      <FormSelect
        label="Grupo de preço"
        placeholder="Selecione o grupo de preço padrão"
        v-model="facebookShopping.grupoPreco"
        :options="facebookShoppingOptions"
      />

      <FormField
        label="Marca padrão"
        placeholder="Marca padrão"
        v-model="facebookShopping.marcaPadrao"
        help="Quando o produto não possuir a característica gênero (facebook-brand) este valor será usado"
      />

      <div class="genero">
        <FormSelect
          label="Gênero padrão"
          placeholder="Selecione o gênero padrão dos produto"
          class="select-genero"
          v-model="facebookShopping.generoPadrao"
          :options="genders"
        />

        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ml-3">far fa-question-circle</v-icon>
          </template>
          Quando o produto não possuir a característica gênero (facebook-gender)
          este valor será usado
        </v-tooltip>
      </div>

      <div class="feeds">
        <label>Feed de produtos(Xml)</label>

        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ml-3 mr-3">far fa-question-circle</v-icon>
          </template>
          Use o endereço abaixo para baixar o arquivo com os produtos.
        </v-tooltip>

        <a :href="urlFacebookShopping" target="_new">
          {{ urlFacebookShopping }}
        </a>
      </div>
    </div>
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import LineDivider from "@/components/LineDivider";
import FormSelect from "@/components/form/FormSelect";
import FormField from "@/components/form/FormField";
import { mapGetters } from "vuex";

export default {
  components: {
    Panel,
    LineDivider,
    FormSelect,
    FormField
  },
  props: {
    dados: {
      type: Object,
      default: function() {
        return {};
      },
      required: false
    }
  },
  data() {
    return {
      facebookShoppingOptions: [],
      facebookShopping: {
        grupoPreco: "",
        marcaPadrao: "",
        generoPadrao: ""
      },
      urlFacebookShopping: null,
      genders: [
        {
          text: "Unisex",
          value: "unisex"
        },
        {
          text: "Masculino",
          value: "male"
        },
        {
          text: "Feminino",
          value: "female"
        }
      ],
      seo: {
        slug: ""
      },
      dominio: ""
    };
  },
  computed: {
    ...mapGetters(["getFornecedorId"])
  },
  watch: {
    dados: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          const groupsOptions = [];

          newVal.priceGroups.forEach(({ codigo_grupo_preco }) => {
            groupsOptions.push({
              text: codigo_grupo_preco,
              value: codigo_grupo_preco
            });
          });

          this.facebookShoppingOptions = groupsOptions;
          this.facebookShopping = newVal.facebookShopping;
          this.dominio = newVal.dominio;
          this.seo = newVal.seo;

          this.urlFacebookShopping =
            this.dominio &&
            `https://${this.dominio}/shopping/${this.seo.slug ||
              this.getFornecedorId}/facebook.xml`;
        }
      }
    },
    facebookShopping: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.$emit("dataToParent", {
            evento: "facebookShopping",
            dados: newVal
          });
        }
      }
    }
  }
};
</script>

<style scoped>
a {
  color: #337ab7;
  font-size: 16px;
  display: block;
  text-align: left;
  text-decoration: none;
  padding-top: 3px;
}

label {
  font-weight: 700;
  color: #6a6c6f;
  padding-top: 3px;
}

.panel {
  margin-top: 30px;
}

.panel .container-panel {
  padding: 0;
}

.feeds {
  display: flex;
}

.genero {
  position: relative;
}

.genero .select-genero {
  width: 98%;
}

.genero i {
  position: absolute;
  top: 8px;
  right: 0;
}

@media (max-width: 1919px) {
  .genero .select-genero {
    width: 95%;
  }
}
</style>
